﻿import './painel-component.css';

var centralApp = angular.module('app.components');

centralApp.component('painel', {
    bindings: {
        titulo: '@',
        icone: '@?',
        subtitulo: '@?',
        ngClass: '=?'
    },
    replace: true, 
    transclude: true,
    template: require('./painel-component-template.html')
});



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/painel/index.js
// module id = 316
// module chunks = 1